import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { CreditCard, Sparkles, Landmark, Crown } from "lucide-react";
import { startCheckout } from "@/pages/PaymentPages";
import { STRIPE_LINK_SCAN_20 } from "@/lib/stripeLinks";
import { toast } from "sonner";

export default function SubscriptionsPage() {
  const { user } = useAuth();
  const { t } = useLang();
  const isSurv = user?.plan === "surveillance";

  const activate = async () => {
    try { await startCheckout("surveillance_monthly"); }
    catch (e) {
      const msg = e?.response?.data?.detail || "Erreur lors de la création du paiement";
      toast.error(msg);
    }
  };

  return (
    <div className="space-y-10" data-testid="subscriptions-page">
      <div>
        <p className="eyebrow mb-1">{t("nav.subscriptions.eyebrow")}</p>
        <h1 className="text-3xl sm:text-4xl font-serif tracking-tight">{t("nav.subscriptions")}</h1>
        <p className="mt-3 text-sm text-muted-foreground max-w-2xl">{t("subscriptions.intro")}</p>
      </div>

      {isSurv ? (
        <div className="hairline p-8 rounded-lg bg-primary text-primary-foreground">
          <div className="flex items-center gap-2 mb-3">
            <Crown className="w-4 h-4" />
            <p className="font-mono text-[10px] uppercase tracking-widest opacity-70">{t("backoffice.plan")}</p>
          </div>
          <p className="font-serif text-3xl">Surveillance</p>
          <p className="text-sm text-primary-foreground/75 mt-2">
            {t("subscriptions.active")}
          </p>
        </div>
      ) : (
        <div className="hairline p-8 rounded-lg bg-card space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <Button
              onClick={activate}
              className="rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 h-14 w-full text-base"
              data-testid="activate-sub-btn"
            >
              <Sparkles className="w-4 h-4 mr-2" /> {t("subscriptions.cta.sub")}
            </Button>
            <a
              href={STRIPE_LINK_SCAN_20}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 h-14 px-4 text-base font-medium transition w-full"
              data-testid="pay-single-scan-btn"
            >
              <CreditCard className="w-4 h-4 mr-2" /> {t("subscriptions.cta.scan")}
            </a>
          </div>
          <div
            className="flex items-start gap-3 p-4 rounded-lg border border-primary/20 bg-primary/5"
            data-testid="subscriptions-payment-methods"
          >
            <Landmark className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
            <p className="text-base font-bold text-foreground leading-snug">
              {t("subscriptions.payment_methods")}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
